import React from "react";
import ExoTable from "../exo/ExoTable";
import { Box, Button } from "@mui/material";
import MoneyLabel from "../label/MoneyLabel";
import { useTranslation } from "react-i18next";
import useFetch from "../../api/useFetch";
import DateLabel from "../label/DateLabel";

export const SelectReceipt = ({ filter, onSelect, className }) => {
  const { t } = useTranslation();

  const { apiData } = useFetch(`receipts?${filter}`);

  const Columns = [
    {
      header: "Nr", // header of column
      key: "id", // key of column in row-object
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
      width: "20px", // width of column
      hiddenMobile: true, // hides the column on mobile
    },
    {
      header: t("Title"), // header of column
      key: "title", // key of column in row-object
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
    },
    {
      header: t("Date"), // header of column
      key: "date", // key of column in row-object
      thAlign: "right", // header text alignment
      tdAlign: "right", // cell text alignment
      sortable: true, // enable sort function for column
      width: "120px", // width of column
      cell: ({ row }) => (
        <Box className="monospace">
          <DateLabel date={row.receiptDate} />
        </Box>
      ), // custom xml for cells in the column. you get the row as object
      hiddenMobile: true, // hides the column on mobile
    },
    {
      header: t("Tax Rate"), // header of column
      key: "taxRate", // key of column in row-object
      thAlign: "right", // header text alignment
      tdAlign: "right", // cell text alignment
      sortable: true, // enable sort function for column
      width: "100px", // width of column
      cell: ({ row }) => <Box className="monospace">{row.taxRate} %</Box>, // custom xml for cells in the column. you get the row as object
      hiddenMobile: true, // hides the column on mobile
    },
    {
      header: t("Volume"), // header of column
      key: "amount", // key of column in row-object
      thAlign: "right", // header text alignment
      tdAlign: "right", // cell text alignment
      sortable: true, // enable sort function for column
      width: "120px", // width of column
      cell: ({ row }) => (
        <Box className="monospace">
          <MoneyLabel money={row.amount} />
        </Box>
      ), // custom xml for cells in the column. you get the row as object
    },
    {
      header: "", // header of column
      key: "file", // key of column in row-object
      thAlign: "right", // header text alignment
      tdAlign: "right", // cell text alignment
      width: "100px", // width of column
      cell: ({ row }) => (
        <Button onClick={() => onSelect(row)} variant="contained">
          {t("Select")}
        </Button>
      ), // custom xml for cells in the column. you get the row as object
    },
  ];
  return (
    <ExoTable
      data={apiData}
      columns={Columns}
      isLoading={!apiData}
      className={className}
    />
  );
};
